import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import DashboardContainer from './dashboard';
import MonitoringContainer from './monitoring';
import MonitoringDeliveryContainer from './monitoring_delivery';
import TrackingContainer from './tracking';
import TemperatureContainer from './temperature';
import TimelineContainer from './timeline';
import LogContainer from './logs';
import {inject, observer} from "mobx-react/index";
// import app_store from "../stores/app";
import ReportContainer from './report';

class IndexContainer extends Component {

    render() {
        const app = this.props.app_store;

        return (
            <div className="app">
                <Switch>
                    <Route exact path="/dashboard" component={DashboardContainer} />

                    {
                        app.configurations.use_temperature &&
                        (<Route exact path="/temperature" component={TemperatureContainer} />)
                    }

                    <Route exact path="/timeline" component={TimelineContainer} />
                    <Route exact path="/tracking" component={TrackingContainer} />
                    <Route exact path="/logs" component={LogContainer} />
                    <Route exact path="/vehicles" component={ReportContainer} />

                    <Route exact path="/" component={MonitoringContainer} />
                    <Route exact path="/:id" render={MonitoringDeliveryContainer} />
                </Switch>
            </div>
        );
    }

}

let container = observer(IndexContainer);
container = inject(['app_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/containers/index.js